<template>
    <div>
        <slot name="button" :openDialog="openDialog">
            <Button rounded @click="openDialog" :icon="'pi ' + icon" :label="label" data-cy="open" />
        </slot>
        <Dialog v-model:visible="open" modal :dismissable-mask="outsideDismiss" :position="modalPosition">
            <template #container="{ closeCallback }">
                <div class="p-2" :style="{ width, height }">
                    <slot></slot>
                    <slot name="close" :closeCallback="closeCallback">
                        <div
                            class="closeButton flex justify-center items-center"
                            @click="closeCallback"
                            data-cy="close"
                        >
                            <span class="pi pi-times"></span>
                        </div>
                    </slot>
                </div>
            </template>
        </Dialog>
    </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

const { icon, label, outsideDismiss } = withDefaults(
    defineProps<{
        icon?: string;
        label?: string;
        outsideDismiss?: boolean;
        width?: string;
        height?: string;
        modalPosition?: string;
    }>(),
    {
        width: "95vw",
        outsideDismiss: true,
        modalPosition: "center",
        label: "",
    }
);
const open = ref(false); // by implementing this as a model we could let the slot also close the window again

const openDialog = () => {
    open.value = true;
};
</script>
<style scoped>
.closeButton {
    cursor: pointer;
    position: absolute;
    top: -0.8rem;
    left: -0.8rem;
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 50%;
}
.generateButton {
    margin-top: 5px;
}
</style>
